import dateFormat from './dateFormat'

const filters = [
  dateFormat
]
export default {
  install(Vue) {
    filters.forEach(filter => {
      Vue.filter(filter.name, filter.filter)
    })
  }
}